/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {refreshPaychecksHome} from '../api'

 export const useQueryRefreshPaychecksHome = createReactQueryHook('refreshPaychecksHome', refreshPaychecksHome)
